import { useState } from "react";
import InputForm from "../riutilizabili/forms/InputForm";
import create_autocompleteWithService from "../riutilizabili/create_autocompleteWithService";
import prodotti_fetch from "../fetch/prodotti_fetch";
import anFornitore_fetch from "../fetch/anFornitore_fetch";
import user_fetch from "../fetch/user_fetch";
import TextAreaForm from "../riutilizabili/forms/TextAreaForm";


export default function CampiOrdini({
    onChange ,
    values ,
    errors={}
}) {
    const [prodSele , setProdSele] = useState({});

    const assMetPag = ({item , value})=> {
        if (item) {
            onChange('prodottoId' , item.id)
            onChange('prodotto' , item)
        }else {
            if (Object.keys(prodSele).length > 0) {
                onChange('prodottoId' , null)
            }
            // onChange('prodottoId' , null)
            // setProdSele({})
        }
    }

    const ProdottiAutocomplite = create_autocompleteWithService({
        freeinput: true,
        service: (myValue, serviceValues) => prodotti_fetch.get({
            nomeCodice: myValue,
            ...serviceValues,
        }),
        itemCompare: (item, inputValue) => (item.descrizione+ ' '+item.rifInterno)?.toLowerCase().indexOf((inputValue || "")?.toLowerCase()) !== -1,
        itemToLi: item => item.descrizione+' - '+ item.rifInterno+ ''+ (item.infoFornitore !== null ? ' - '+item.infoFornitore.nome : ' '),
        itemToString: item => item.descrizione+' - '+ item.rifInterno,
        itemFind: (value, items) => items.reduce((acc, curr) => acc || (curr?.nome.toLowerCase() === value?.toLowerCase() ? curr : null), null),
        label: 'Seleziona prodotto',
        placeholder: 'Selezione rapida : inserisci codice interno o descrizione articolo',
        value : !!values?.prodotto?.descrizione ? values?.prodotto?.descrizione  +' - '+ values?.prodotto?.rifInterno : '',
        onChange : assMetPag ,
        className :' w-100 m-0 ' ,
    });

    const onChangeOrdinatoDa = ({item , value}) => {
        if (item) {
           //console.log(item , value);
            onChange('ordinatoDaId', item.id)
            onChange('anNominazioneOrdinatoDa', value)
        }
    }

    const onChangeFornitore = ({item , value}) => {
        if (item) {
           //console.log(item , value);
            onChange('fornitoreId', item.id)
            onChange('anNominazioneFornitore', value)
        }
    }
   //console.log(values ,' values');
    
    const AutocompleteFornitore = create_autocompleteWithService({
    freeinput: false,
    service: (myValue, serviceValues) => anFornitore_fetch.autocompliteAn({
        nome: myValue,
        ...serviceValues,
    }),
    itemCompare: (item, inputValue) => item.viewName?.toLowerCase().indexOf((inputValue || "")?.toLowerCase()) !== -1,
    itemToLi: item => item.viewName,
    itemToString: item => item.viewName,
    itemFind: (value, items) => items.reduce((acc, curr) => acc || (curr?.viewName.toLowerCase() === value?.toLowerCase() ? curr : null), null),
    onChange: onChangeFornitore ,
    //redflag : redflagFonia,
    label: 'Seleziona Fornitore :',
    placeholder: 'inserisci Fornitore',
    value: values?.fornitore?.viewName || values?.anNominazioneFornitore,
});
    
    const AutocompleteOrdinatoDa = create_autocompleteWithService({
    freeinput: false,
    service: (myValue, serviceValues) => user_fetch.get({
        nome: myValue,
        ...serviceValues,
    }),
    itemCompare: (item, inputValue) => item.username?.toLowerCase().indexOf((inputValue || "")?.toLowerCase()) !== -1,
    itemToLi: item => item.username,
    itemToString: item => item.username,
    itemFind: (value, items) => items.reduce((acc, curr) => acc || (curr?.username.toLowerCase() === value?.toLowerCase() ? curr : null), null),
    onChange: onChangeOrdinatoDa ,
    //redflag : redflagFonia,
    label: 'Ordinato da ',
    placeholder: 'inserisci utente',
    value: values?.ordinatoDa?.username || values?.anNominazioneOrdinatoDa,
});

    return(
        <div className="d-flex flex-wrap">
            <div className="col-7">
                <ProdottiAutocomplite />
            </div>
            <div className="col-5 ps-4">
                <AutocompleteFornitore />
            </div>
            <InputForm
                label='Quantità*'
                name='qt'
                value={values?.qt}
                onChange={onChange}
                errors={errors}
            />
            <InputForm
                label='Data per cui è richiesto il articolo'
                type={'date'}
                name='dataRichiestaPer'
                value={values?.dataRichiestaPer}
                onChange={onChange}
                errors={errors}
            />
            <InputForm
                label="Data ordine"
                type={'date'}
                name='dataOrdine'
                value={values?.dataOrdine}
                onChange={onChange}
                errors={errors}
            />

            <InputForm
                label="Data per cui è previsto l'arrivo"
                type={'date'}
                name='dataArrivoPrev'
                value={values?.dataArrivoPrev}
                onChange={onChange}
                errors={errors}
            />

            <div className="col-3 pt-3 ps-2">
                <AutocompleteOrdinatoDa />
            </div>
            <TextAreaForm
                label='Note'
                name='note'
                value={values?.note}
                onChange={onChange}
                classi='col-8'
                errors={errors}
            />
        </div>
    )
}